 (function () {  
    function insertSectionCartDrawer() {
      const cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      let wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
      const existingUpsells = wrapper && wrapper.querySelector('#cart-drawer-upsell')
      if (cartDrawerItems.classList.contains('is-empty')) {
        if (existingUpsells) existingUpsells.remove()
        return
      }

      if (!wrapper) {
        wrapper = document.createElement('div')
        wrapper.classList.add('cart-drawer-items-wrapper')
        cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
        wrapper.appendChild(cartDrawerItems)
      }

      const source = document.querySelector('#cart-drawer-upsell-wrapper #cart-drawer-upsell')
      if (source && source.querySelector('.cart-drawer-upsell-list li')) {
        if (existingUpsells) existingUpsells.remove()
        wrapper.insertAdjacentHTML('beforeend', source.outerHTML)
      } else if (existingUpsells) {
        existingUpsells.remove()
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return

      let timer
      let requestVersion = 0
      let controller
      const observerOptions = { childList: true, subtree: true }
      const observer = new MutationObserver((mutations) => {
        // Cart rendering replaces these nodes; ignore spinners, focus and our own upsell markup.
        const cartChanged = mutations.some((mutation) =>
          mutation.target.matches('#CartDrawer, .drawer__inner') ||
          [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
            node.nodeType === 1 &&
            (node.matches('cart-drawer-items') || node.querySelector('cart-drawer-items'))
          )
        )
        if (!cartChanged) return

        clearTimeout(timer)
        const version = ++requestVersion
        if (controller) controller.abort()
        timer = setTimeout(async () => {
          const requestController = new AbortController()
          controller = requestController
          const url = new URL(window.location.href)
          url.searchParams.delete('sections')
          url.searchParams.set('section_id', 'cart-drawer')

          try {
            const response = await fetch(url.toString(), { cache: 'no-store', signal: requestController.signal })
            if (!response.ok) throw new Error('Unable to refresh cart recommendations')
            const text = await response.text()
            if (version !== requestVersion) return
            const newDocument = new DOMParser().parseFromString(text, 'text/html')
            const source = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            const currentSource = document.querySelector('#cart-drawer-upsell-wrapper')
            if (!source || !currentSource) return

            observer.disconnect()
            try {
              currentSource.replaceWith(source)
              insertSectionCartDrawer()
            } finally {
              observer.observe(element, observerOptions)
            }
          } catch (error) {
            if (error.name !== 'AbortError') console.error(error)
          }
        }, 100)
      })

      // Reuse Shopify's bundled section instead of fetching recommendations again.
      window.refreshCartDrawerUpsells = function (sectionHtml) {
        if (!sectionHtml) return
        const source = new DOMParser().parseFromString(sectionHtml, 'text/html')
          .querySelector('#cart-drawer-upsell-wrapper')
        const currentSource = document.querySelector('#cart-drawer-upsell-wrapper')
        if (!source || !currentSource) return
        clearTimeout(timer)
        ++requestVersion
        if (controller) controller.abort()
        observer.disconnect()
        try {
          currentSource.replaceWith(source)
          insertSectionCartDrawer()
        } finally {
          observer.observe(element, observerOptions)
        }
      }

      observer.observe(element, observerOptions)
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();